import { createApp } from "vue";
import App from "./App.vue";
import { router } from "./router";
import { getAuthToken, refreshRoles } from "./helpers/store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $config: Record<string, unknown>;
  }
}

// Load roles before mounting so the nav guard has them on the first navigation
// (e.g. a hard refresh on /bursts by an external_user). On failure we mount
// anyway with empty roles — on a 401 fetchWithToken has already cleared the
// stale token and redirected to /login.
const bootstrap = async () => {
  if (getAuthToken()) {
    try {
      await refreshRoles();
    } catch (error) {
      console.warn("Failed to load roles on boot:", error);
    }
  }
  const app = createApp(App).use(router);
  app.mount("#app");
};

bootstrap();
